import React from 'react';
import { useNavigate } from 'react-router';
import { firestoreCollectionRead, firestoreDocUpdate, firestoreWrite, signInEmailAndPassword } from '../../../service/common/firebase';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../store/reducer-main';
import { Card, Image, Input, Link } from '@nextui-org/react';
import PageLayout from '../../components/common/PageLayout';
import logo from '../../../assets/wilma_care_welcome_logo.svg'
import Button from '../../components/common/Button';
import Typography from '../../components/common/Typography';
import theme from '../../theme';
import bgImage from '../../../assets/login_page_bg.png';
import AdminDataFooter from '../../components/common/AdminDataFooter';
import { selectedPurchaseSessionProduct } from '../../../store/purchaseSession/slice';
import { USER_DB_REF } from '../../../constants/firestore';
import { Family } from '../../../types/families';
import { CareGiver } from '../../../types/caregivers';
import { Calculation } from '../../../types/calculation';

const defaultContent = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.";

export default function LoginPage() {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loadingProfile } = useSelector((state: StoreState) => state.profile);

  const [email, setEmail] = React.useState<string>('');
  const [password, setPassword] = React.useState<string>('');
  const [fbLoading, setFbLoading] = React.useState<boolean>(false); // loading firebase auth

  const submitDisabled = React.useMemo(() => {
    if (email.length === 0) return true;
    if (password.length === 0) return true;
    return false;
  }, [email, password]);

  const loading = React.useMemo(() => {
    return fbLoading || loadingProfile;
  }, [fbLoading, loadingProfile, email, password]);

  const submit = async () => {
    try {
      setFbLoading(true);
      await signInEmailAndPassword({ email, password });
      setFbLoading(false);
    } catch (error) {
      console.log('login error', error);
      setFbLoading(false);
    }
  }

  const onGotoSignUp = () => {
    dispatch(selectedPurchaseSessionProduct(null));
    navigate('/auth/signup');
  }

  const test = () => {
    const dest_uid = 'wblCWV66Iscc7OBrRZPKi3FN7u13';
    const send_uid = 'paScqAKiPnXzXSv5gQoaWPyAEcu1';
    // famiglie
    /* firestoreCollectionRead(`${USER_DB_REF}/${send_uid}/families`).then(s => {
      s.forEach(async(snap) => {
        const data = snap.data() as Family;
        await firestoreWrite(`${USER_DB_REF}/${dest_uid}/families`, data.id, data);
        console.log('migrato famiglia', data.id);
      })
    }) */
      /* firestoreCollectionRead(`${USER_DB_REF}/${send_uid}/caregivers`).then(s => {
        s.forEach(async(snap) => {
          const data = snap.data() as CareGiver;
          await firestoreWrite(`${USER_DB_REF}/${dest_uid}/caregivers`, data.id, data);
          console.log('migrato badante', data.id);
        })
      }) */
  }

  return (
    <PageLayout 
      style={{
        padding: `${theme.sizing.x3} ${theme.sizing.x9}`,
        backgroundImage: `url(${bgImage})`
      }}>
      <div className='flex w-full h-auto justify-between items-center'>
        <img src={logo} alt='Wilmacare' className="w-1/2 min-w-[200px] sm:w-1/2 md:w-1/3 lg:w-1/4 h-auto"/>
        <div className='flex gap-6'>
          <Button
            onClick={() => navigate('/auth/products')}
            colorVariant='secondary'
            textStyle={{fontWeight: 700}}
            textColorVariant='primary'
            className='w-40'
            title='PREZZI'/>
        </div>
      </div>
      <div className='flex flex-1 justify-between items-center gap-8'>
        <Card className='px-6 py-8 min-w-96'>
          <Typography variant='headline2' className='text-center'>Autenticazione</Typography>
          <div className='flex flex-col gap-6 mb-12 mt-10'>
            <Input 
              value={email} 
              onValueChange={setEmail} 
              type="email" label="Email" />
            <Input 
              value={password} 
              onValueChange={setPassword} 
              type="password" 
              label="Password" />
          </div>
          <div className='flex flex-col gap-6'>
            <Button 
              title='ACCEDI' 
              loading={loading}
              disabled={loading || submitDisabled}
              onClick={submit} 
              variant='secondary' />
            <Button 
              title='CREA ACCOUNT' 
              onClick={onGotoSignUp} />
          </div>
        </Card>
        <div className='flex flex-col flex-1 max-w-4xl'>
          {/* <Typography
            className='text-center' 
            variant='headline2' 
            colorVariant='background'>
            Rivoluziona il modo in cui vengono gestiti i servizi di assistenza
          </Typography> */}
          <Typography 
            className='text-center' 
            variant='headline2' 
            colorVariant='background'>
              Rivoluziona il modo in cui vengono gestiti i servizi di assistenza
            </Typography>
          <Typography 
            className='text-center mt-8' 
            variant='headline1' 
            colorVariant='background'>
              Trova la badante giusta con la scala di compatibilità Wilma Care
            </Typography>
          <Typography 
            className='text-center mt-16' 
            variant='display' 
            colorVariant='background'>
              La <strong>scala di compatibilità Wilma Care</strong> offre ai professionisti del recruitment tutti gli strumenti necessari per
              la scelta del personale domestico.
          </Typography>
          <Typography
            className='text-center mt-2' 
            variant='display' 
            colorVariant='background'>
              Attraverso degli algoritmi di calcolo basati sulle conoscenze delle badanti e sui bisogni della famiglia, la <strong>scala di compatibilità Wilma Care</strong> è stata progettata per semplificare ed ottimizzare il processo di valutazione.
          </Typography>
          <Typography
            className='text-center mt-2' 
            variant='display' 
            colorVariant='background'>
              La <strong>scala di compatibilità Wilma Care</strong> offre un sistema di preferenze accurato, basato su parametri certi ed
              oggettivi. Potrai creare un database completo dei colloqui effettuati, permettendo una gestione più
              organizzata e trasparente delle informazioni.
          </Typography>
          <Typography
            className='text-center mt-2' 
            variant='display' 
            colorVariant='background'>
              Grazie ad un sistema di calcolo intelligente, la <strong>scala di compatibilità Wilma Care</strong> suggerisce la badante più
              adatta tra quelle presenti negli archivi, migliorando l’efficienza per le aziende di ricerca e selezione.
          </Typography>
        </div>
      </div>
      <AdminDataFooter />
    </PageLayout>
  )
}